/**
 * Read-aloud lever (2026-09-09).
 *
 * Default-ON, opt-out — the same shape as messageReactionsEnabled, so the
 * rollback is one environment variable and no code change:
 *
 *   REACT_APP_READ_ALOUD=off
 *
 * The server has its own instant-off (`ops/readAloud.enabled:false`, no
 * deploy). This one takes the control off the surface.
 */
export function readAloudEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_READ_ALOUD ?? '').trim().toLowerCase() !== 'off';
}
